import { Stack } from "@similarweb/ui-components/foundations";

import { DomainManager } from "./domain-manager";

export type DomainsIncludeExcludeState = {
    include: string[];
    exclude: string[];
};

interface IDomainsIncludeExcludeTexts {
    includeTitle?: string;
    excludeTitle?: string;
    includePlaceholder?: string;
    excludePlaceholder?: string;
    searchingText?: string;
    label?: string;
    labelFallback?: string;
    singleIncluded?: string;
    singleExcluded?: string;
}

const defaultTexts: Required<IDomainsIncludeExcludeTexts> = {
    includeTitle: "Only include competitors from these domains:",
    excludeTitle: "Exclude competitors from these domains:",
    includePlaceholder: "Include domains...",
    excludePlaceholder: "Exclude domains...",
    searchingText: "Searching domains...",
    label: "Include/Exclude Domains",
    labelFallback: "Include/Exclude Domains",
    singleIncluded: "included",
    singleExcluded: "excluded",
};

interface IDomainsIncludeExcludeRendererProps {
    state?: DomainsIncludeExcludeState;
    onChange: (value: DomainsIncludeExcludeState) => void;
    texts?: IDomainsIncludeExcludeTexts;
}

export const DomainsIncludeExcludeRenderer = (props: IDomainsIncludeExcludeRendererProps) => {
    const { state = { include: [], exclude: [] }, onChange, texts = {} } = props;

    const finalTexts = { ...defaultTexts, ...texts };

    return (
        <Stack
            gap="16px"
            padding="8px 8px 0"
        >
            <DomainManager
                title={finalTexts.includeTitle}
                placeholder={finalTexts.includePlaceholder}
                searchingText={finalTexts.searchingText}
                domains={state.include}
                onDomainsChange={(domains: string[]) => {
                    onChange({
                        ...state,
                        include: domains,
                    });
                }}
            />
            <DomainManager
                strikethrough
                title={finalTexts.excludeTitle}
                placeholder={finalTexts.excludePlaceholder}
                searchingText={finalTexts.searchingText}
                domains={state.exclude}
                onDomainsChange={(domains: string[]) => {
                    onChange({
                        ...state,
                        exclude: domains,
                    });
                }}
            />
        </Stack>
    );
};
